import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";
import { useGoogleMaps } from "@/context/GoogleMapsContext";
import { grayMapStyle } from "@/utils/variables";
import {
  DrawingManager,
  GoogleMap,
} from "@react-google-maps/api";
import { useState } from "react";

const PerimeterDialogDraw = () => {
  const [open, setOpen] = useState(false);
  const [center] = useState({
    lat: 41.3275,
    lng: 19.8189,
  });

  const { isLoaded, loadError } = useGoogleMaps();

  if (loadError) {
    return <div>Error loading maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading Maps...</div>;
  }

  return (
    <>
      <Button
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
      >
        Create perimeter
      </Button>
      {open && (
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogContent className="sm:max-w-[1000px]">
            <DialogTitle>Draw perimeter</DialogTitle>
            {loadError && <div>Error loading maps</div>}
            {!isLoaded && <div>Loading Maps...</div>}
            {open && isLoaded && !loadError && (
              <div className="h-full relative">
                <GoogleMap
                  center={center}
                  zoom={11}
                  mapContainerClassName="h-[600px] w-full"
                  options={{
                    styles: grayMapStyle,
                    fullscreenControl: false,
                    streetViewControl: false,
                    mapTypeControl: false,
                  }}
                >
                  <DrawingManager
                    onOverlayComplete={(e) => {
                      const overlay = e.overlay;
                      overlay.setDraggable(true);
                      overlay.setOptions({
                        editable: true,
                        clickable: true,

                      })

                      overlay.addListener("rightclick", () => {
                        overlay.setMap(null);
                      });

                    }}

                  />
                </GoogleMap>
              </div>
            )}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default PerimeterDialogDraw;
